var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0AA8F0",
    d: "M14.228 18.503c0-.177-.135-.32-.3-.32h-4.37c-.166 0-.3.143-.3.32 0 .178.134.32.3.32h4.37c.165 0 .3-.142.3-.32",
    transform: "translate(.283 .29)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0AA8F0",
    d: "M13.361 18.503L10.125 18.503 10.57 14.541 12.915 14.541z",
    transform: "translate(.283 .29)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#334599",
    d: "M21.813 16.115H1.673C.918 16.115.3 15.455.3 14.65V1.564C.3.76.918.1 1.673.1h20.14c.755 0 1.373.659 1.373 1.464v13.087c0 .805-.618 1.464-1.373 1.464",
    transform: "translate(.283 .29)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0AA8F0",
    d: "M20.897 13.142H2.59c-.62 0-1.128-.541-1.128-1.203V2.357c0-.661.507-1.202 1.128-1.202h18.308c.62 0 1.128.54 1.128 1.202v9.582c0 .662-.508 1.203-1.128 1.203M12.165 14.568c0 .249-.19.45-.422.45-.233 0-.422-.201-.422-.45 0-.248.189-.45.422-.45.233 0 .422.202.422.45",
    transform: "translate(.283 .29)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternet);
export default __webpack_public_path__ + "static/media/internet.6cdbc321563a635c90b8d991e66d9f69.svg";
export { ForwardRef as ReactComponent };